<template>
    <div class="col-md-12 mb-4" v-if="prices.length > 0">
        <div class="container-box">
            <div class="container-box-title">{{ translate.account.prices }}</div>
            <div class="container-box-content" id="profile-page-prices">
                <table class="price-table">
                    <tbody>
                    <tr v-for="price in prices" :key="price.id">
                        <td>{{ getName(price.name) }}</td>
                        <td :data-prefix="translate.home.inCall" :class="{'hidden': !price.incall}">
                            {{ (price.incall) ? (regionData.currency + price.incall) : '-' }}
                        </td>
                        <td :data-prefix="translate.home.outCall" :class="{'hidden': !price.outcall}">
                            {{ (price.outcall) ? (regionData.currency + price.outcall) : '-' }}
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
<script>

function getName(name) {
    return _.get(this, `translate.account.priceNames.${name}`, name);
}

export default {
    computed: {
        ...mapState(['translate', 'regionData']),
    },
    props: {
        prices: {default: []},
    },
    methods: {
        getName
    }
}
</script>
